<template>
  <div class="productList" ref="container">
    <!-- <CommonHeader title="商品详情"></CommonHeader> -->
    <img style="display: block; width: 100%;" :src="image" alt="" v-if="image" />
    <div style="position: relative; min-height: 100vh;  padding-bottom: 0.2rem;">
      <div style="position: absolute; inset: 0;" :style="{ background: `no-repeat url(${image_base}) center / 100% 100%` }"></div>
      <div class="list acea-row row-between-wrapper list-box" style="position: relative; z-index: 2">
        <div @click="goDetail(item)" v-for="(item, index) in productList" :key="index" class="item" :title="item.store_name">
          <div class="pictrue item-1" :class="Switch === true ? '' : 'on'">
            <img style="position:absolute;right: 0;" :src="item.image" :class="Switch === true ? '' : 'on'" />
            <!-- <div class="icon-mianxi" v-if="Switch === true">
              <span>{{ item.fenqi_num }}期</span>
              <span>免息</span>
            </div> -->
            <div class="interest-free-tag">
              <span style="font-size: 0.32rem;">20%</span>
              <br>积分抵扣  
            </div>
            <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '1'">秒杀</span>
            <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '2'">砍价</span>
            <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '3'">拼团</span>
          </div>
          <div class="text" :class="Switch === true ? '' : 'on'">
            <div class="name line1">{{ item.store_name }}</div>
            <div class="money font-color-red mianxi" :class="Switch === true ? '' : 'on'">
              <div>
                ￥<span class="num">{{ item.fenqi_price }}</span>
                <span style="color: black; font-weight: normal; font-size: 0.26rem;"> /期起</span>
              </div>

              <div class="m-ico" v-if="Switch !== true">{{ item.fenqi_num }}期免息</div>
            </div>
            <div style="font-size:0.3rem;color:#ccc;" :class="Switch === true ? '' : 'on'">
              ￥<span class="num">{{ item.price }}</span>
            </div>
            <div class="vip acea-row row-between-wrapper" :class="Switch === true ? '' : 'on'">
              <div class="vip-money" v-if="item.vip_price && item.vip_price > 0">￥{{ item.vip_price }}<img src="@assets/images/vip.png" /></div>
              <!-- <div>已售{{ item.sales }}件</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div class="noCommodity" v-cloak style="background-color: #fff;" v-if="productList.length === 0 && where.page > 1">
      <div class="noPictrue">
        <img src="@assets/images/noGood.png" class="image" />
      </div>
    </div>
    <Recommend v-if="productList.length === 0 && where.page > 1"></Recommend>
  </div>
</template>

<script>
import Recommend from "@components/Recommend";
import { getProducts, getProductClassCollection } from "@api/store";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";
import CommonHeader from "@components/CommonHeader";

export default {
  components: {
    Recommend,
    Loading,
    CommonHeader,
  },
  props: {},
  data: function() {
    const { s = "", id = 0, title = "" } = this.$route.query;
    return {
      hostProduct: [],
      productList: [],
      Switch: true,
      where: {
        id: this.$route.params.id,
        page: 1,
        limit: 10,
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false,
      image: "",
      image_base: "",
      collection_color: "",
    };
  },
  watch: {
    title() {
      this.updateTitle();
    },
  },
  mounted: function() {
    this.updateTitle();
    this.get_product_list();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.get_product_list();
    });
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    get_product_list: debounce(function() {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      this.setWhere();
      let q = that.where;
      getProductClassCollection(q).then((res) => {
        that.loading = false;
        that.image = res.data.image;
        that.collection_color = res.data.color;
        that.image_base = res.data.image_base;
        that.productList.push.apply(that.productList, res.data.list);
        that.loadend = res.data.list.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    }, 300),
    submitForm: function() {
      this.$set(this, "productList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.get_product_list();
    },
    //点击事件处理
    set_where: function(index) {
      let that = this;
      switch (index) {
        case 0:
          return that.$router.push({ path: "/category" });
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.$set(that, "productList", []);
      that.where.page = 1;
      that.loadend = false;
      that.get_product_list();
    },
    //设置where条件
    setWhere: function() {
      let that = this;
      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }
      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }
      that.where.news = that.nows ? "1" : "0";
    },
    switchTap: function() {
      let that = this;
      that.Switch = !that.Switch;
    },
    handleBack() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.icon-mianxi {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 0.7rem;
  height: 0.7rem;
  font-size: 0.22rem;
  color: #fff;
  background: #f00;
}
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
.list-box {
  margin-top: 0 !important;
}
.item-1 {
  border: 0.04rem #fff solid;
}
.bottom-1 {
  height: 0.2rem;
}
.interest-free-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  color: #fff;
  font-size: 0.18rem;
  padding: 0.08rem 0.15rem;
  border-radius: 0 0 0 0.1rem;
  font-weight: 500;
}
</style>
